import React, { useContext, useEffect, useState } from "react";
import TableBetting from "components/TableBetting";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../config/axios";
import { useDebouncedCallback } from 'use-debounce';
import refactorStructureData from "../../helpers/refactorDataMenu";
import { RootContext } from '../../App'
export default function BettingDetail() {
  const history = useHistory();
  const [listPlayer, setListPlayer] = useState();
  const [pending, setPending] = useState(true);
  const [optionsLevel, setOptionLevel] = useState([])
  const [username, setUsername] = useState(null)
  const [active, setActive] = useState(null)
  const [level, setLevel] = useState(null)
  const [length, setLength] = useState(100)
  const { state, setState } = useContext(RootContext)


  const debounced = useDebouncedCallback(
    (action) => {
      action()
    },
    200
  );

  useEffect(() => {

    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    username, active, level, length,
  ]);

  const getData = () => {
    const token = localStorage.getItem("access_token");

    const group = JSON.parse(localStorage.getItem("group"))
    const data = {
      token: token,
      group: group.wbid,
      user: username,      
      lgth: length,
    }
    if (!token) {
      history.push("/login");
    } else {
      try {

        axiosInstance("winlose_player", {
          method: "POST",
          data,
        })
          .then((res) => {
            // console.log(res)
            const array = res.data.data;
            const result = [];

            array.forEach((item) => {
                const found = result.find((r) => r.username === item.username);
                if (found) {
                    found.stake += item.stake;
                    found.wl += item.wl - item.stake;
                } else {
                  result.push(item);
                }
            });

            let arr = result;
            
            for (let i = 0; i < arr.length; i++) {
              let element = arr[i];
              // Ganti nama key jadi turnover dan menang_kalah
              element['turnover'] = element['stake'];
              element['menang_kalah'] = element['wl'];
              delete element['stake'];
              delete element['wl'];
            }
            // console.log(arr);

            // const data = res.data.data.list
            const data = arr;
            setListPlayer(data);
            setPending(false);

            setState({
              ...state,
              group: res.data.data.additional_data.group,
              menu: refactorStructureData(res.data.data.additional_data.menu),
            });

            const level = res.data.data.adv_search.level
            level.unshift({ leid: null, name: 'All' })
            setOptionLevel(level)

          })
          .then(() => {
          })
          .catch((err) => {
            // localStorage.removeItem("access_token");
            // history.push("/login");
          });
      } catch (error) {
        console.log("ERROR: ", error);
      }
    }
  };


  return (
    <>
      <div className="bg-light-blue-500 pt-7 pb-28 px-3 md:px-8 h-auto"></div>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <TableBetting
              title="Player List"
              listPlayer={listPlayer}
              optionsLevel={optionsLevel}
              pending={pending}

             
              usernameEvent={(event) => {

                debounced(() => setUsername(event.target.value))

              }}
              activeEvent={(event) => {
                setActive(event.value)
              }}
             
              onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                setLength(currentRowsPerPage)
              }}
              levelEvent={(event) => {
                setLevel(event.value)

              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
